import { ref } from 'vue';

export enum DRAG_STATUS {
  /** 不支持的内容 */
  READY = 'READY',
  DRAGGING = 'DRAGGING',
  PROGRESS = 'PROGRESS',
}

export function useDrag() {
  const dragStatus = ref(DRAG_STATUS.READY);

  let counter = 0;
  /**
   * 拖拽进入事件
   */
  const handleDragEnter = (event: any) => {
    counter++;
    dragStatus.value = DRAG_STATUS.DRAGGING;
    console.log('拖拽进入事件');
  };

  /**
   * 拖拽移出事件
   */
  const handleDragLeave = (event: any) => {
    counter--;
    if (counter !== 0) {
      return;
    }
    dragStatus.value = DRAG_STATUS.READY;
    console.log('拖拽移出事件');
  };

  /**
   * 拖拽move事件
   */
  const handleDragOver = (event: any) => {
    event.preventDefault();
    dragStatus.value = DRAG_STATUS.DRAGGING;
    console.log('拖拽移动事件');
  };

  /**
   * 拖拽drop事件
   */
  function handleDrop(event: any) {
    event.preventDefault();
    counter = 0;
    dragStatus.value = DRAG_STATUS.READY;

    console.log('拖拽drop事件', event);
  }

  return {
    dragStatus,
    handleDragEnter,
    handleDragLeave,
    handleDragOver,
    handleDrop,
  };
}
